import React from "react";
import {
  useTheme,
  Box,
  AppBar,
  makeStyles,
  Theme,
  createStyles,
  MobileStepper,
  Button,
  Grid,
  Hidden,
  useScrollTrigger,
  useMediaQuery
} from "@material-ui/core";
import { Quote } from "../../../api/Quote/Quote";
import { colors } from "swyft-react-core";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@material-ui/icons";
import { TF } from "../../../components/typography/TF";

const QuoteAddonWizardTop = ({ quote, activeStep, onNext, onBack, steps, btnNextText }: Props) => {
  const classes = useStyles();
  const theme = useTheme();
  const isSmall = useMediaQuery(theme.breakpoints.down("sm"));
  return (
    <>
      <ElevationScroll className={classes.root} scrollClassName={classes.appScroll}>
        <AppBar className={classes.root} position={isSmall ? "fixed" : "static"} color="transparent">
          <Grid container className={classes.grid}>
            <Grid item xs={12} container alignItems="center">
              <Box fontSize="1.5rem" className={classes.button}>
                <Button onClick={onBack} color="secondary">
                  {theme.direction === "rtl" ? (
                    <KeyboardArrowRight color="primary" />
                  ) : (
                    <KeyboardArrowLeft color="primary" />
                  )}
                  <Hidden mdDown>Back</Hidden>
                </Button>
              </Box>
              <Hidden mdUp>
                <Box flexGrow={1} p={1}>
                  <TF variant="caption">Total</TF>
                  <TF variant="body1" bold format="price">
                    {quote.price}
                  </TF>
                </Box>
                <Box mr={2}>
                  <Button onClick={onNext} variant="contained" color="secondary">
                    {btnNextText()}
                  </Button>
                </Box>
              </Hidden>
            </Grid>
            <Grid item xs={12}>
              <MobileStepper
                variant="progress"
                steps={steps + 1}
                position="static"
                activeStep={activeStep + 1}
                className={classes.stepper}
                nextButton={null}
                backButton={null}
                color="secondary"
              />
            </Grid>
          </Grid>
        </AppBar>
      </ElevationScroll>
      <Box className={classes.mobileHelper}></Box>
    </>
  );
};

export default QuoteAddonWizardTop;

interface Props {
  onBack: () => void;
  onNext: () => void;
  quote: Quote;
  activeStep: number;
  steps: number;
  btnNextText: () => string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.16)",
      top: theme.spacing(7),
      backgroundColor: colors.white,
      [theme.breakpoints.down("sm")]: {}
    },
    appScroll: {
      boxShadow: "0px 3px 6px 0px rgba(0, 0, 0, 0.16)",
      backgroundColor: colors.white
    },
    grid: {
      position: "relative"
    },
    button: {
      borderRight: "1px solid " + colors.lightGrey,
      padding: theme.spacing(1),
      paddingRight: theme.spacing(3),
      [theme.breakpoints.down("sm")]: {
        "padding": 0,
        '& [class*="MuiButton-root"]': {
          minWidth: theme.spacing(1)
        }
      }
    },
    stepper: {
      "width": "100%",
      "position": "absolute",
      "bottom": 0,
      "padding": 0,
      '& [class*="MuiLinearProgress-barColorPrimary"]': {
        backgroundColor: colors.secondary
      },
      '& [class*="MuiMobileStepper-progress"]': {
        width: "100%",
        height: "3px"
      }
    },
    mobileHelper: {
      marginTop: theme.spacing(7),
      [theme.breakpoints.up("md")]: {
        display: "none"
      }
    }
  })
);

interface ScrollProps {
  className: string;
  scrollClassName: string;
  children: React.ReactElement;
}

const ElevationScroll = (props: ScrollProps) => {
  const { children, className, scrollClassName } = props;
  const trigger = useScrollTrigger({
    disableHysteresis: true,
    threshold: 0
  });

  return React.cloneElement(children, {
    className: trigger ? scrollClassName : className
  });
};
